import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import "./Styles/modal-component.scss";
const ModalComponent = (props = {}) => {
  const {
    data,
    styles,
    styleCloseContainer,
    styleCloseIcon,
    styleCloseText,
    closeText = `Close`,
    closeIcon,
    onClose,
    afterOpen,
    modalIsOpen,
    setModalIsOpen,
    showCloseIcon = true,
    showCloseText = true,
  } = props;

  const mainStyles = {
    overlay: {
      position: "fixed",
      inset: "0",
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      zIndex: 5,
    },
    content: {
      background: "transparent",
      border: "none",
      inset: "0px",
      position: "absolute",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      flexWrap: "wrap",
      flexDirection: "column",
      paddingTop: 100,
    },
  };

  const closeContainerStyle = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    width: 40,
    height: 40,
    backgroundColor: "#F3F5F7",
    position: "absolute",
    marginTop: 20,
    borderRadius: 40,
    marginLeft: 310
  };

  const closeIconStyle = {
    color: "black",
    fontSize: "1.2em",
  };

  const closeTextStyle = {
    color: "red",
    fontSize: "1.5em",
    marginLeft: "10px",
  };

  const afterOpenModal = () => {
    // document.body.classList.add("modal-open");

    if (afterOpen) {
      afterOpen();
    }
  };

  const closeModal = () => {
    // document.body.classList.remove("modal-open");

    setModalIsOpen(false);
    if (onClose) {
      onClose();
    }
  };

  const closeIconElement = (
    <div style={styleCloseContainer || closeContainerStyle}>
      {showCloseIcon ? <FontAwesomeIcon style={styleCloseIcon || closeIconStyle} icon={closeIcon || faTimes} onClick={closeModal}></FontAwesomeIcon> : null}
      {showCloseText ? <span style={styleCloseText || closeTextStyle}>{closeText}</span> : null}
    </div>
  );
  return (
    <div className="modal-component">
      <Modal style={styles || mainStyles} isOpen={modalIsOpen} onAfterOpen={afterOpenModal} onRequestClose={closeModal} ariaHideApp={false} backdrop="static">
        {data}
        {closeIconElement}
      </Modal>
    </div>
  );
};

export default ModalComponent;
